module.exports = __webpack_public_path__ + "img/3.762675cb.jpg";